import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-muted mt-2 ms-2 fw-bold fs-6" }

import * as pkg from '../../../package.json';
import NavbarLogo from './NavbarLogo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarLeftItem',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavbarLogo),
    _createElementVNode("small", _hoisted_1, _toDisplayString(pkg.version), 1)
  ], 64))
}
}

})